<!-- <div class="main">
    <p-card>
        <form class="form-container" [formGroup]="createShipmentAsnForm" (ngSubmit)="onSubmit()">
            <div class="withReference">
                <div class="section-container">
                    <div class="cus">
                        <h5><strong>Invoice Detail</strong></h5>
                        <div class="flex flex-column gap-2 mt-3">
                            <label>Invoice/ Challan No<span class="required-asterisk">*</span></label>
                            <input pInputText formControlName="invoice_challan_no">
                        </div>
                        <div class="flex flex-column gap-2 mt-3">
                            <label>Invoice Date<span class="required-asterisk">*</span></label>
                            <p-calendar formControlName="invoice_date" [iconDisplay]="'input'" [showIcon]="true"
                                dateFormat="dd/mm/yy" [showButtonBar]="true"  [minDate]="minDateValue"></p-calendar>
                        </div>
                        <div class="flex flex-column gap-2 mt-3">
                            <label>Actual Delivery Date and Time<span class="required-asterisk">*</span></label>
                            <p-calendar formControlName="actual_delivery_date_and_time" [iconDisplay]="'input'"
                                [showIcon]="true" [showTime]="true" dateFormat="dd/mm/yy"
                                [showButtonBar]="true"  [minDate]="minDateValue"></p-calendar>
                        </div>
                    </div>
                    <div class="cus">

                        <h5><strong>Packing Detail</strong></h5>
                        <div class="flex flex-column gap-2 mt-3">
                            <label>Packing Type<span class="required-asterisk">*</span></label>
                            <p-dropdown [options]="packingTypes" optionLabel="mns_of_transport"
                                optionValue="mns_of_transport" placeholder="Select Packing Type"
                                formControlName="packing_type"></p-dropdown>
                        </div>
                        <div class="flex flex-column gap-2 mt-3">
                            <label>Total Number</label>
                            <input pInputText formControlName="total_number"  (keydown)="validateNumber($event)">
                        </div>
                        <div class="flex flex-column gap-2 mt-3">
                            <label>Total Net Weight</label>
                            <input pInputText formControlName="total_net_weight"  (keydown)="validateNumber($event)" >
                        </div>
                        <div class="flex flex-column gap-2 mt-3">
                            <label>Total Gross Weight</label>
                            <input pInputText formControlName="total_gross_weight"  (keydown)="validateNumber($event)">
                        </div>
                    </div>
                    <div>
                        <h5><strong>Delivery Detail</strong></h5>
                        <div class="flex flex-column gap-2 mt-3">
                            <label>Deliver from</label>
                            <p-dropdown [options]="unloadingPoints" optionLabel="name_of_unloading_point"
                                optionValue="name_of_unloading_point" placeholder="Select Delivery From point"
                                formControlName="deliver_from"></p-dropdown>
                        </div>
                        <div class="flex flex-column gap-2 mt-3">
                            <label>Deliver To</label>
                            <p-dropdown [options]="loadingPoints" optionLabel="name_of_loading_point"
                                optionValue="name_of_loading_point" placeholder="Select Delivery To point"
                                formControlName="deliver_to"></p-dropdown>
                        </div>
                        <div class="flex flex-column gap-2 mt-3">
                            <label>Route</label>
                            <p-dropdown [options]="route" optionLabel="description" optionValue="description"
                                placeholder="Select Route" formControlName="route"></p-dropdown>
                        </div>
                        <div class="flex flex-column gap-2 mt-3">
                            <label>Expected Delivery Date</label>
                            <p-calendar formControlName="expected_delivery_date" [iconDisplay]="'input'"
                                [showIcon]="true" dateFormat="dd/mm/yy" [showButtonBar]="true"  [minDate]="minDateValue"></p-calendar>
                        </div>
                    </div>
                    <div class="pay">
                        <h5><strong>Driver Detail</strong></h5>
                        <div class="flex flex-column gap-2 mt-3">
                            <label>Driver Name</label>
                            <p-dropdown [options]="driverList" optionLabel="name"
                                placeholder="Select Driver" (onChange)="onSelectDriver($event.value)" formControlName="driver_name"></p-dropdown>
                        </div>
                        <div class="flex flex-column gap-2 mt-3">
                            <label for="driverMobileNo">Driver Mobile No</label>
                            <input id="driverMobileNo" type="text" pInputText placeholder="Driver Mobile No" formControlName="driver_mobile_no" (input)="enforceCharacterLimit($event)">
                          </div>
                        <div class="flex flex-column gap-2 mt-3">
                            <label>Vehicle No</label>
                            <p-dropdown [options]="vehicleNoList" optionLabel="vehicle_no"
                            placeholder="Select Vehicle No" (onChange)="onSelectVehicleNo($event.value)" formControlName="vehicle_number"></p-dropdown>
                          </div>
                          <div class="flex flex-column gap-2 mt-3">
                            <label>Vehicle Type</label>
                            <input pInputText formControlName="vehicle_type" placeholder="Vehicle Type">
                        </div>
                    </div>
                </div>
                <div class="field-row">
                    <div class="field">
                        <label>Schedule Delivery</label> &nbsp;
                        <p-multiSelect [options]="selectedRows" [(ngModel)]="selectedScopes"
                            [ngModelOptions]="{standalone: true}" optionLabel="itemNo"
                            selectedItemsLabel="{0} users selected"></p-multiSelect>
                    </div>
                </div>
            </div>
            <div style="text-align: center;">
                <p-button label="Submit" (click)="onSubmit()"></p-button>
            </div>
        </form>
    </p-card>
</div>
<p-toast></p-toast> -->

<div class="grid" [formGroup]="createShipmentAsnForm">
    <div class="col-12 md:col-6">
        <div class="card p-fluid">
            <h5>Invoice Detail</h5>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label>Invoice/ Challan No<span class="required-asterisk">*</span></label>
                    <input pInputText formControlName="invoice_challan_no">
                    <div *ngIf="createShipmentAsnForm.get('invoice_challan_no')?.hasError('existingInvoice') && createShipmentAsnForm?.get('invoice_challan_no')?.touched"
                            class="text-red-300">
                            This Invoice number already exists.
                    </div>
                </div>
                  <div class="field col">
                    <label>Invoice Date<span class="required-asterisk">*</span></label>
                    <p-calendar formControlName="invoice_date" [iconDisplay]="'input'" [showIcon]="true"
                        dateFormat="dd/mm/yy" [showButtonBar]="true" [minDate]="minDateValue"></p-calendar>
                </div>
            </div>

            <h5>Packing Detail</h5>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label>Packing Type<span class="required-asterisk">*</span></label>
                    <p-dropdown [options]="packingTypes" optionLabel="mns_of_transport" optionValue="mns_of_transport"
                        placeholder="Select Packing Type" formControlName="packing_type"></p-dropdown>
                </div>
                <div class="field col">
                    <label>Total Number</label>
                    <p-inputNumber formControlName="total_number"> </p-inputNumber>
                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label>Total Net Weight (kg)</label>
                    <p-inputNumber formControlName="total_net_weight" mode="decimal" [minFractionDigits]="2"
                        [maxFractionDigits]="5"> </p-inputNumber>
                </div>
                <div class="field col">
                    <label>Total Gross Weight (kg)</label>
                    <p-inputNumber formControlName="total_gross_weight" mode="decimal" [minFractionDigits]="2"
                        [maxFractionDigits]="5">
                    </p-inputNumber>
                    <div *ngIf="createShipmentAsnForm.get('total_gross_weight')?.errors?.['grossWeightLessThanNetWeight']">
                        <small class="text-danger">Total Gross Weight must be greater than Total Net Weight.</small>
                    </div>

                </div>
                <div class="field col">
                    <label>Select UQC Code</label>
                    <p-autoComplete [dropdown]="true" formControlName="uqc_code" [suggestions]="filteredUQCCode"
                        (completeMethod)="filteredUQC($event)"></p-autoComplete>
                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="field col">
                    <p-button label="Submit" (click)="onSubmit()"></p-button>
                </div>
                <div class="field col">
                </div>
                <div class="field col">
                </div>
            </div>
            <p-dialog header="Create QR Code" [closable]="false" [(visible)]="isTokenCreateDialog" [modal]="true"
            [style]="{ width: '40rem' }">
            <ng-template pTemplate="body">
                <div><h3>You Want To Create QR.</h3></div>
            </ng-template>
            <ng-template pTemplate="footer">
                <p-button (click)="isTokenCreateDialog = false"  label="NO"></p-button>
                <p-button (click)="generatePdfWithQRCode()"  label="YES"></p-button>
            </ng-template>
            <!-- [disabled]="isAddBtnDisable"  -->
            </p-dialog>
        </div>
    </div>

    <div class="col-12 md:col-6">
        <div class="card p-fluid">
            <h5>Driver Detail</h5>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label>Driver Name <span class="required-asterisk">*</span></label>
                    <p-autoComplete [dropdown]="true" formControlName="driver_name"
                        (onSelect)="onSelectDriver($event.value)" [suggestions]="DriverListOfData"
                        (completeMethod)="filtereDriverName($event)" optionLabel="name"></p-autoComplete>
                </div>
                <div class="field col">
                    <label for="driverMobileNo">Driver Mobile No<span class="required-asterisk">*</span></label>
                    <input id="driverMobileNo" type="text" pInputText
                        formControlName="driver_mobile_no" (input)="enforceCharacterLimit($event)">
                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label>Vehicle No<span class="required-asterisk">*</span></label>
                    <p-autoComplete [dropdown]="true" formControlName="vehicle_number"
                        (onSelect)="onSelectVehicleNo($event.value)" [suggestions]="vehicleListOfData"
                        (completeMethod)="filtereVehicleNo($event)" optionLabel="vehicle_no"></p-autoComplete>

                </div>
                <div class="field col">
                    <label>Vehicle Type<span class="required-asterisk">*</span></label>
                    <p-dropdown [options]="vehicleTypeList" placeholder="Vehicle Type"
                        formControlName="vehicle_type"></p-dropdown>
                </div>
            </div>
            <h5>Delivery Detail</h5>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label>Deliver from</label>
                    <p-dropdown [options]="deliverFromList" formControlName="deliver_from"
                        styleClass="w-17rem"></p-dropdown>
                </div>
                <div class="field col">
                    <label>Deliver To</label>
                    <!-- <p-dropdown [options]="plantList" optionLabel="name" optionValue="name"
                        formControlName="deliver_to"></p-dropdown> -->
                    <p-multiSelect [options]="plantList" formControlName="deliver_to" optionLabel="name"
                        [ngModel]="selectedPlants"></p-multiSelect>
                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label>Route</label>
                    <p-dropdown [options]="routeList" optionLabel="name" placeholder="Select Route"
                        (onChange)="onSelectRoute($event.value)" formControlName="route"></p-dropdown>

                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label>Dispatch Date<span class="required-asterisk">*</span></label>
                    <p-calendar formControlName="dispatch_date" [iconDisplay]="'input'"
                                [showIcon]="true" [showTime]="true" dateFormat="dd/mm/yy"
                                [showButtonBar]="true"  [minDate]="minDateValue"  (ngModelChange)="onDispatchDate($event)"></p-calendar>
                                <!-- <div *ngIf="createShipmentAsnForm.errors?.['dates']">
                                    <small class="text-danger">{{ createShipmentAsnForm.errors?.['dates'] }}</small>
                                  </div> -->
                    <!-- <p-calendar formControlName="dispatch_date" [iconDisplay]="'input'" [showIcon]="true"
                        dateFormat="dd/mm/yy HH:mm" [showButtonBar]="true" [minDate]="minDateValue"></p-calendar> <br> -->
                    <!-- <span style="display: block; text-align: center;">{{duration}}</span> -->
                </div>
                <div class="field col">
                    <label>Expected Delivery Date<span class="required-asterisk">*</span></label>
                    <p-calendar formControlName="expected_delivery_date" [iconDisplay]="'input'"
                                [showIcon]="true" [showTime]="true" dateFormat="dd/mm/yy"
                                [showButtonBar]="true"  [minDate]="minDateValue"></p-calendar>
                    <!-- <p-calendar formControlName="expected_delivery_date" [iconDisplay]="'input'" [showIcon]="true"
                        dateFormat="dd/mm/yy" [showButtonBar]="true" [minDate]="minDateValue"></p-calendar> <br> -->
                    <span style="display: block; text-align: center;">{{duration}}</span>

                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label>Schedule Delivery</label> &nbsp;
                    <p-multiSelect [options]="selectedRows" [(ngModel)]="selectedScopes"
                        [ngModelOptions]="{standalone: true}" optionLabel="item_no"
                        selectedItemsLabel="{0} users selected"></p-multiSelect>
                </div>
                <div class="field col">
                </div>
            </div>
        </div>
    </div>
</div>
<p-toast></p-toast>
